import { createAction, props } from '@ngrx/store'
import {
  IFinanceExpensesData,
  IFinanceOverviewState,
  IFinanceSubscription,
  IFinanceSubscriptionInfo
} from '@adex/shared/models/states/finance.state'


export const loadFinanceOverview = createAction(
  '[Finance] Load Finance Overview'
)

export const setFinanceOverviewState = createAction(
  '[Finance] Set Finance Overview State',
  props<{ state: IFinanceOverviewState }>()
)

export const loadFinanceExpenses = createAction(
  '[Finance] Load Finance Expenses'
)

export const setFinanceExpensesData = createAction(
  '[Finance] Set Finance Expenses Data',
  props<{ data: IFinanceExpensesData[] }>()
)

export const setFinanceExpensesHasMorePage = createAction(
  '[Finance] Set Finance Expenses Has More Page',
  props<{ hasMore: boolean }>()
)

export const setFinanceExpensesPageIndex = createAction(
  '[Finance] Set Finance Expenses Page Index',
  props<{ page: number }>()
)

export const recharge = createAction(
  '[Finance] Recharge',
  props<{ amount: number }>()
)

export const setSubscriptionsTypeState = createAction(
  '[Finance] Set Subscriptions Type State',
  props<{ state: IFinanceSubscription[] }>()
)

export const setSubscriptionsInfoState = createAction(
  '[Finance] Set Subscriptions Info State',
  props<{ state: IFinanceSubscriptionInfo }>()
)

export const selectSubscription = createAction(
  '[Finance] Select Subscription',
  props<{ id: number }>()
)

export const trialActivate = createAction(
  '[Finance] Trial Activation',
  props<{ subscriptionType: number, successUrl: string, failUrl: string }>()
)

export const addPaymentMethod = createAction(
  '[Finance] Add payment method',
  props<{ successUrl: string, failUrl: string }>()
)

